import React, { Children, ReactElement } from 'react';
import { connect } from 'react-redux';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { buildGroupInitialUrl } from '~/ProductGroup';
import { ApplicationState } from '~/Store';

const LinkRenderer: React.FC<
	React.PropsWithChildren<{
		link: {
			pathname: string;
			search: string;
		};
		children: (link: { pathname: string; search: string }) => ReactElement<any, any> | null;
	}>
> = ({ children, link }) => children(link);

function mapStateToProps(
	state: ApplicationState,
	{ group }: { group: UserProductGroup }
): {
	link: {
		pathname: string;
		search: string;
	};
} {
	return {
		link: buildGroupInitialUrl(group, state),
	};
}

export default connect(mapStateToProps)(LinkRenderer);
